<div appBsModal #mySettingsManualModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <span *ngIf="!isMyProfileEdit">{{"PersonalDetails" | localize}}</span>
                    <span *ngIf="isMyProfileEdit">{{"MyProfile" | localize}}</span>
                </h5>
                <button type="button" *ngIf="isMyProfileEdit" class="close" [attr.aria-label]="l('Close')"
                    (click)="close()">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body" *ngIf="user">
                <tabset>
                    <tab heading="{{'UserDetails' | localize}}">
                        <app-user-details-manual [staff]="user" [ownDetailsEdit]="true"
                            [isOnboardingCompleted]="isOnboardingCompleted" [isMyProfileEdit]="isMyProfileEdit">
                        </app-user-details-manual>
                    </tab>

                    <tab *ngIf="isGranted('Pages.Activities.GetOfMyOwnSubordinates')" heading="{{'DirectReports' | localize}}">
                        <div style="padding: 1em; padding-bottom: 2.5em;">
                            <app-direct-reports [staff]="user" [ownDetailsEdit]="true">
                            </app-direct-reports>
                        </div>
                    </tab>
                </tabset>
            </div>
        </div>
    </div>
</div>